import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class SpeechService {
  recognition: SpeechRecognition | null = null;
  private lastFinalTranscript: string = ''; // Track the last final transcript

  constructor() {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (SpeechRecognition) {
      this.recognition = new SpeechRecognition();
      this.recognition.continuous = true; // Enable continuous recognition
      this.recognition.interimResults = true; // Enable interim results
      this.recognition.lang = 'en-US'; // Set the language
    } else {
      console.error('Speech recognition is not supported in this browser.');
    }
  }

  startRecognition(onResult: (text: string) => void, onError?: (error: Event) => void) {
    if (!this.recognition) return;

    this.recognition.onresult = (event: SpeechRecognitionEvent) => {
      let interimTranscript = '';
      let finalTranscript = '';

      // Process all results
      for (let i = event.resultIndex; i < event.results.length; i++) {
        const transcript = event.results[i][0].transcript;
        if (event.results[i].isFinal) {
          finalTranscript += transcript + ' ';
        } else {
          interimTranscript += transcript;
        }
      }

      // Only send the final transcript if it's new
      if (finalTranscript.trim() !== this.lastFinalTranscript.trim()) {
        this.lastFinalTranscript = finalTranscript.trim();
        onResult(finalTranscript.trim());
      }
    };

    this.recognition.onerror = (error: Event) => {
      if (onError) onError(error);
    };

    this.recognition.start();
  }

  stopRecognition() {
    this.recognition?.stop();
    this.lastFinalTranscript = ''; // Reset the last final transcript
  }
}